import { gql } from "@apollo/client";

//Returns List
export const ReturnsListQuery = `
query GetAllReturns($filter: ReturnsFilterInput) {
  getAllReturns(filter: $filter) {
    success
    error
    message
    data {
      id
      salesOrder
      isOldSo
      status
      rejectedReason
      reason
      createdAt
      updatedAt
      returnpickupstatus {
        id
        status
        remarks
      }
 			customerName
      agentAssigned
      user {
        id
        employeeName
      }
    }
  }
}
`;

//Delete Returns
export const DeleteReturnsManagement = gql`
  mutation DeleteReturn($returnId: ID!) {
    deleteReturns(returnId: $returnId) {
      success
      error
      message
    }
  }
`;

// Sales Order Numbers
export const allSalesOrders = gql`
  query {
    allsalesorders {
      id

      sio

      discount

      totalAmount

      grandTotal

      status

      customer {
        id

        customerName
      }

      user {
        id

        username
      }

      salesorderproductSet {
        id

        product {
          id

          productName
        }

        quantity

        tax

        taxAmount

        amount

        totalAmount
      }
    }
  }
`;

//Products
export const allProducts = gql`
  query {
    allProducts {
      success

      error

      message

      data {
        id

        productCode

        productName

        productCategory

        productBrandCode
        productImage

        productBrand

        productUom

        baseUom

        conversion

        vat

        bas

        cod

        csh

        smt

        vansl

        createdAt

        lastupdate
      }
    }
  }
`;

//Status Change
export const statusChangeMutation = `
mutation ApproveOrRejectReturn($input: ApproveOrRejectReturnsInput!) {
  approveOrRejectReturns(input: $input) {
    success
    error
    message
  }
}
`;

//Delivered
export const allDeliveredQuery = gql`
  query {
    completedDeliveries {
      success
      error
      message
      data {
        id
        deliveryId
        salesOrder {
          id
          orderDate
          totalAmount
          soNumber
        }
        salesOrderDate
        repName
        repCode
        customerName
        customerAddress
        typeOfCreation
        deliveryStatus
        visitStatus
        deliveredDate
        deliveredOn
        reason
        contactPerson
        contactNumber
        paymentMode
        createdAt
        updatedAt
        deliveryProducts {
          id
          productCode
          productName
          quantity
          createdAt
          updatedAt
        }
      }
    }
  }
`;

//Create Mutation Returns
export const createReturnMutation = gql`
  mutation CreateReturnRequest($input: CreateReturnsInput!) {
    createReturns(input: $input) {
      success
      error
      message
      returnId
    }
  }
`;

export const getReturnsDataById = gql`
  query GetReturnById($returnId: ID!) {
    getReturnById(returnId: $returnId) {
      success
      error
      message
      data {
        id
        salesOrder
        isOldSo
        status
        rejectedReason
        reason
        createdAt
        customerName
        returnProducts {
          id
          product {
            productName
            productCode
          }
          productNameManual
          returnQuantity
          returnReason
        }
        user {
          id
          employeeName
        }
      }
    }
  }
`;

// Assign Delivery Agent Mutation
export const assignDeliveryAgent = gql`
  mutation AssignDeliveryAgent($input: AssignDeliveryAgentInput!) {
    assignDeliveryAgent(input: $input) {
      success
      error
      message
    }
  }
`;

export const deliveryAgentsQuery = gql`
  query {
    allUsers {
      id
      employeeName
      employeeCode
      email
      contactNumber
      address
      role {
        id
        role
      }

      department
      createdAt

      profilePicture

      webUse

      mobileUse
      isActive
    }
  }
`;

export const getSalesorderLite = gql`
  query GetSalesOrderLite($id: Int!) {
    getSalesorderLite(id: $id) {
      success
      message
      error
      data {
        id
        orderDate
        customer {
          id
          customerName
        }
        salesorderproductSet {
          id
          product {
            id
            productName
            productCode
          }
        }
      }
    }
  }
`;
